import CTAButton from '@/components/shared/CTAButton'

const VehicleClaimSteps = ({ vehicleMake }) => {
  return (
    <section className="py-12 md:py-16">
      <div className="container mx-auto max-w-6xl px-4">
        <h2
          className="mb-4 text-3xl font-bold"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          <strong>
            Start Your {vehicleMake} Car Finance Claim in Just{' '}
            <span className="font-raleway-numbers">60</span> Seconds
          </strong>
        </h2>

        <p
          className="mb-12 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          You may have been mis-sold {vehicleMake} car finance. Now is a great
          time to take action. Starting your claim is quick, easy and hassle
          free.
        </p>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div className="bg-card border-foreground group rounded-lg border-2 p-6 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <h3 className="text-primary font-raleway-numbers mb-2 text-2xl font-bold">
              Step 1
            </h3>
            <h4
              className="mb-4 text-xl font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              We Locate Your {vehicleMake} Finance
            </h4>
            <p
              className="leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Using trusted credit reference agencies, our system finds all{' '}
              {vehicleMake} car finance agreements linked to you—even if
              you&apos;ve changed your name or moved home. This includes
              agreements dating back to{' '}
              <span className="font-raleway-numbers">2007</span> which are often
              hard for individuals to trace.
            </p>
          </div>

          <div className="bg-card border-foreground group rounded-lg border-2 p-6 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <h3 className="text-primary font-raleway-numbers mb-2 text-2xl font-bold">
              Step 2
            </h3>
            <h4
              className="mb-4 text-xl font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              We Get Things Moving
            </h4>
            <p
              className="leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Our technology identifies any past {vehicleMake} car finance
              agreements, even those dating back to{' '}
              <span className="font-raleway-numbers">2007</span>, which are
              often difficult for individuals to locate.
            </p>
          </div>

          <div className="bg-card border-foreground group rounded-lg border-2 p-6 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg">
            <h3 className="text-primary font-raleway-numbers mb-2 text-2xl font-bold">
              Step 3
            </h3>
            <h4
              className="mb-4 text-xl font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              We Build Your {vehicleMake} Claim
            </h4>
            <p
              className="leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Your {vehicleMake} case is handed to our expert partner law firm
              who negotiate directly with lenders on a{' '}
              <strong>No win, no fee³</strong> basis.
            </p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <CTAButton />
        </div>
      </div>
    </section>
  )
}

export default VehicleClaimSteps
